// Do not import i18n here or other imports that needed 'window'
// since this file is used in a PDF web worker context where 'window' is not available.

import { SoQLType } from 'common/types/soql';
import { type TableColumn } from 'common/components/PdfPreviewModal/types';

/**
 * Returns default column alignment based on data type.
 *
 * **IMPORTANT**: This function mirrors `getCellAlignment()` in common/DataTypeFormatter.js
 * but operates on `TableColumn` (with `type` property) instead of `ViewColumn` (with `renderTypeName`).
 * The alignment logic MUST be kept in sync with `getCellAlignment()`. If that function changes
 * which data types align left/right/center, this function MUST be updated to match.
 *
 * @param column - TableColumn with `type` property (SoQLType)
 * @returns Lowercase alignment values ('center', 'right', 'left').
 *          For Excel export and future use, capitalize the result (e.g., `getDefaultColumnAlignment(col).charAt(0).toUpperCase() + ...`).
 */
export const getDefaultColumnAlignment = (column: TableColumn): string => {
  const columnType = (column as TableColumn).type;
  switch (columnType) {
    case SoQLType.SoQLBooleanT:
    case SoQLType.SoQLBooleanAltT:
      return 'center';
    case SoQLType.SoQLNumberT:
      return 'right';
    case SoQLType.SoQLFloatingTimestampT:
      return 'left';
    default:
      return 'left';
  }
};
